export default __webpack_public_path__ + "static/media/daily-verse-home-header.c21be566.png";